
export const words: { [key: string]: { [key: string]: string; }} = {

    badCredentials:    { heb: 'שם המשתמש או הסיסמה שהוזנו שגויים', arab: 'اسم المستخدم او الرقم السري غير صحيح' },
    defaultSignin:     { heb: 'כניסה דרך ההזדהות האחידה',          arab: 'تسجيل الدخول لموقع عل ما داع' },
    credentialsSignin: { heb: 'כניסה עם שם משתמש וסיסמה',          arab: 'الدخول من خلال اسم المستخدم والرقم السري' },
    userName:          { heb: 'שם משתמש',                          arab: 'الاسم' },
    password:          { heb: 'סיסמה',                             arab: 'الرمز السري' },
    resetPassword:     { heb: 'לאיפוס סיסמה',                      arab: 'اعادة تعين كلمة المرور' },
    zvisGmail:         { heb: 'לכל שאלה כתבו ל',                   arab: 'ارسل واكتب اسئلتك الخاصة ل' },
    
}

/*

G_heb_to_ar_add["שם"]="الاسم"
G_heb_to_ar_add["מייל"]="الْبَرِيد الإلِكْتُرُونِيّ "
G_heb_to_ar_add["שם המורה"]="إسْم الْمُعَلِّم "
G_heb_to_ar_add["בית ספר"]="المدرسة"
G_heb_to_ar_add["בואו נתחיל"]="هيا نبدأ"
G_heb_to_ar_add["התנתק"]="تَسْجِيل الْخُرُوج "
G_heb_to_ar_add["מבואות"]="مُقَدِّمَات "

G_heb_to_ar_add["התנתק"]="تَسْجِيل الْخُرُوج ";
G_heb_to_ar_add["שאלות ברוח פיזה"]="تَمارِين بيزا PISA ";
G_heb_to_ar_add["מה באתר"]="ماذا يوجد في الموقع";
G_heb_to_ar_add['תרגילי פיז"ה']="تَمارِين بيزا PISA "
G_heb_to_ar_add['ערבית']="عربي "
G_heb_to_ar_add["פרקי רענון"]="فصول تحديثية"

*/